import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  styled,
  Typography,
} from "@mui/material";
import React from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1200px",
  margin: "auto",
  padding: "16px",

  "& .lpl_faq_gr": {
    fontWeight: 700,
    fontSize: "2.5rem",
    textAlign: "center",
    background: "linear-gradient(90deg, #EA580C 0%, #000000 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },

  "& .MuiAccordion-root ": {
    boxShadow: "none",
    borderTop: "1px solid #E2E8F0",
  },
  "& .MuiAccordion-root::before ": {
    backgroundColor: "transparent",
  },
  "& .MuiAccordionSummary-root": {
    minHeight: 64,
  },
}));

const faqs = [
  {
    question: "It is secure my all earing ?",
    answer:
      "Our refund policy allows for returns within 30 days of purchase, provided the product is in its original condition.",
  },
  {
    question:
      "Can your system handle multiple locations for our spa and salon chain?",
    answer:
      "You can contact our customer support team via email at support@example.com or call us at 123-456-7890.",
  },
  {
    question:
      "Does your platform offer integration with popular payment gateways for seamless transactions?",
    answer:
      "Yes, we offer international shipping to most countries. Shipping fees and delivery times vary by location.",
  },
  {
    question:
      "Does your system provide analytics and reporting to track our business performance?",
    answer:
      "We accept major credit cards, PayPal, and other secure payment options.",
  },
  {
    question:
      "How does your system ensure data security and privacy for our client information?",
    answer:
      "Once your order is shipped, we will send you a tracking number via email. You can use this number to track your package on our website.",
  },
];

function Faqs() {
  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <Typography variant="h1" className="lpl_faq_gr">
        Frequently asked questions
      </Typography>
      {faqs.map((faq, index) => (
        <Accordion key={index}>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls={`panel${index + 1}-content`}
            id={`panel${index + 1}-header`}
          >
            <Typography>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </MainView>
  );
}

export default Faqs;
